"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationItem = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var context_1 = require("../context");
function NotificationItem(props) {
    var id = props.id, notification = props.notification;
    var title = notification.title, _a = notification.duration, duration = _a === void 0 ? 4000 : _a, type = notification.type;
    var notifications = (0, context_1.useNotifications)();
    var typeStyles;
    var fontSize;
    switch (type) {
        case 'success':
            typeStyles = {
                background: core_ui_1.colors.grass[400],
            };
            fontSize = 'small';
            break;
        case 'error':
            typeStyles = {
                background: core_ui_1.colors.fire[500],
            };
            fontSize = 'small';
            break;
        default:
            typeStyles = {
                background: '#042553',
            };
            fontSize = 'regular';
    }
    (0, react_1.useEffect)(function () {
        if (duration <= 0)
            return function () { return undefined; };
        var timeout = setTimeout(function () { return notifications.remove(id); }, duration);
        return function () {
            clearTimeout(timeout);
        };
    }, [duration]);
    return (react_1.default.createElement("div", { style: __assign({ minWidth: 300, maxWidth: 400, paddingRight: 40, boxShadow: '2px 2px 16px rgba(38, 45, 70, 0.15)', borderRadius: 4, marginBottom: 8, position: 'relative', padding: 16, color: '#fff', display: 'flex', alignItems: 'center' }, typeStyles) },
        react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center", gap: 16, justifyContent: "center", width: "100%" },
            type === 'success' && react_1.default.createElement(core_ui_1.IconTick, { size: 16 }),
            type === 'error' && react_1.default.createElement(core_ui_1.IconCross, { color: "#ffffff", size: 16 }),
            react_1.default.createElement(core_ui_1.Text, { color: "white", textAlign: "center", size: fontSize }, title))));
}
exports.NotificationItem = NotificationItem;
